import React, { Component } from 'react'
import { withRouter } from "react-router-dom";
import { Box, Paragraph, Text, TextInput, Button } from 'grommet';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
/*import { CheckOldPasswordCtrl } from '../Controllers/CheckOldPasswordCtrl';
import { NewPasswordCtrl } from '../Controllers/NewPasswordCtrl';
import { logout } from '../Utils/Utility';*/

/*class Error extends React.Component {

    render() {

        return (

            <Box>
                {this.props.testo.length > 0 ? <Text className='error'>{this.props.testo}</Text> : <div className='margin-error'></div>}
            </Box>
        );
    }
}*/

class InsertPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: '',
            disableButtonOldPwd: true,
            step: 1,
            disableButtonNewPwd: true,
            msgError: ''
        }
        this.continue = this.continue.bind(this);
        this.setPassword = this.setPassword.bind(this);
        this.setNewPassword = this.setNewPassword.bind(this);
        this.setConfirmPassword = this.setConfirmPassword.bind(this);
    }

    setPassword(e) {
        this.setState({
            oldPassword: e.target.value
        }, function () {
            if (this.state.oldPassword.length > 4) {

                this.setState({
                    disableButtonOldPwd: false
                })
            }
            else {
                this.setState({
                    disableButtonOldPwd: true
                })
            }
        })
    }

    /*checkOldPassword() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        CheckOldPasswordCtrl(function (data) {
            self.setState({
                data: data === undefined ? [] : data
            });
        }, function (error) {
            self.setState({
                status: error
            }, function(){
                if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })  
                } else if (this.state.status === 401) {
                    logout();
                    this.props.history.push({
                    pathname: '/login'
                    })
                } 
            })

        }, this.state, token, ids);
    }

    sendNewPassword() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        NewPasswordCtrl(function (data) {
            self.setState({
                data: data === undefined ? [] : data
            });
        }, function (error) {
            self.setState({
                status: error
            }, function(){
                if(this.state.status === 500 || this.state.status === 400 || this.state.status === 404 || this.state.status === 403){
                    this.props.history.push({
                        pathname: '/ErrorPage',
                        state: this.state
                    })  
                } else if (this.state.status === 401) {
                    logout();
                    this.props.history.push({
                    pathname: '/login'
                    })
                } 
            })

        }, this.state, token, ids);
    }*/

    setNewPassword(e) {
        this.setState({
            newPassword: e.target.value
        }, function () {
            if (this.state.newPassword.length > 4 && (this.state.newPassword === this.state.confirmNewPassword)) {
                this.setState({
                    disableButtonNewPwd: false
                })
            }
            else {
                this.setState({
                    disableButtonNewPwd: true
                })
            }
        })
    }

    setConfirmPassword(e) {
        this.setState({
            confirmNewPassword: e.target.value
        }, function () {
            if (this.state.confirmNewPassword.length > 4 && (this.state.newPassword === this.state.confirmNewPassword)) {
                this.setState({
                    disableButtonNewPwd: false
                })
            }
            else {
                this.setState({
                    disableButtonNewPwd: true
                })
            }
        })
    }

    continue() {
        this.props.history.push({
            pathname:'/OTPCode'
        })
    }

    render() {

        return (

            <Box>
                <Header/>


                <Box direction="column" align='center' className='background-color'>
                        <Box direction='row' >
                            <h1 className='fixFont' level='1' style={{ marginBottom: '50px' }}>Inserisci una nuova password</h1>
                            <Text className='titlehome' style={{ marginBottom: '5px' }}></Text>
                        </Box>
                        <Box style={{ height: '280px' }}>
                            <Box direction='row' justify='center'>
                                <Paragraph className='textParagraph'> Inserisci la nuova password e conferma</Paragraph>
                            </Box>
                            <Box direction='column' margin='small'>
                                <Text className='label'>NUOVA PASSWORD</Text>
                                <TextInput id='password' type='password' size='medium' className='inputFormdisp' value={this.state.newPassword} onChange={this.setNewPassword} />
                                {
                                    //<Error testo={this.props.msgcodpv} />
                                }
                            </Box>
                            <Box direction='column' margin='small'>
                                <Text className='label'>CONFERMA NUOVA PASSWORD</Text>
                                <TextInput onBlur={() => this.state.newPassword !== this.state.confirmNewPassword ? this.setState({ error: 'le password non combaciano' }) : this.setState({ error: null })}
                                    id='confirmpwd' type='password' onChange={this.setConfirmPassword} className='inputFormreset' value={this.state.confirmNewPassword} confirmpwd={this.state.confirmNewPassword} placeholder='' />
                                {
                                    // <Error testo={this.state.error} />
                                }
                            </Box>
                        </Box>
                        <Box justify='center' direction='row'>
                            <Button className='btnform' disabled={this.state.disableButtonNewPwd} style={{ width: '170px' }} onClick={this.continue}>AVANTI</Button>
                        </Box>
                    </Box>
                    <Footer />
            </Box>
        )
    }
}

export default InsertPassword = withRouter(InsertPassword)